<template>
    <HeaderComp/>
    <main class="py-5 px-2">
        <router-view></router-view>
    </main>
    <FooterComp/>
</template>

<script>
import HeaderComp from '../../components/Auth/Header.vue'
import FooterComp from '../../components/Auth/Footer.vue'
export default {
    name: 'AuthView',
    components: {
        HeaderComp,
        FooterComp
    }
}
</script>

<style lang="scss" scoped>
    main {
        background-color: #F8F8F8;
    }
</style>